import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { TellAFriendApiParameter } from "@insite/client-framework/Services/EmailService";
import { ShareProductParameter,SendDataToApi, chain } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";
import { tellAFriendV2 } from "@tSurya/Services/ShareProductService";

type HandlerType = ApiHandlerDiscreteParameter<ShareProductParameter, TellAFriendApiParameter, TellAFriendModel>;

export const SendDataToApiCustom: HandlerType = async props => {
    props.apiResult = await tellAFriendV2(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, SendDataToApiCustom);